import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const DescriptionSVG = ({
  fill = '#BCBEC2',
  size = '14',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="10"
      fill="none"
      viewBox="0 0 14 10"
      {...otherSvgProps}
    >
      <path
        fill={fill}
        d="M0 1a1 1 0 011-1h6.556a1 1 0 110 2H1a1 1 0 01-1-1zM9.334 1a1 1 0 011-1H13a1 1 0 110 2h-2.666a1 1 0 01-1-1zM5.444 5a1 1 0 011-1H13a1 1 0 110 2H6.444a1 1 0 01-1-1zM0 5a1 1 0 011-1h2.667a1 1 0 110 2H1a1 1 0 01-1-1zM0 9a1 1 0 011-1h12a1 1 0 110 2H1a1 1 0 01-1-1z"
      ></path>
    </svg>
  </span>
);

export default DescriptionSVG;
